export const saveDotloopSettings = async (tempMapping) => {

    try {
        const response = await fetch('https://functionappfordev.azurewebsites.net/api/dotloopSettingsHandler', {
            method: 'POST',
            headers: { 
                'Content-Type': 'application/json',
                'X-UserSessionID': localStorage.getItem('UserSessionID') || ''
             },
            body: JSON.stringify({ 
                newDotloopSettings: tempMapping
             }),
            // credentials: 'include' // Include credentials for CORS
        });

        if (!response.ok) {
            throw new Error('Failed to fetch tokens');
        }

        const data = await response.json();
        console.log(data);
        
        return data;
    } catch (error) {
        console.error('Error saving Dotloop settings:', error);
        throw error;
        // return [];
    }

  }
